import Swiper from "swiper";

let initialized = false;

let popupExterior;
let swiperExterior;
let popupInterior;
let swiperInterior;

export function closePopupExterior() {
  popupExterior.classList.remove("open");
}

export function openPopupExterior(index) {
  popupExterior.classList.add("open");
  swiperExterior.slideToLoop(index, 0);
}

export function closePopupInterior() {
  popupInterior.classList.remove("open");
}

export function openPopupInterior(index) {
  popupInterior.classList.add("open");
  swiperInterior.slideToLoop(index, 0);
}

function initPopup() {
  if (initialized) {
    return;
  }

  initialized = true;

  popupExterior = document.getElementById("j360_popup_exterior");
  popupInterior = document.getElementById("j360_popup_interior");

  // -- add click event to close
  document.querySelectorAll(".js-popup-close").forEach(function (cls) {
    cls.addEventListener("click", function () {
      // -- close popup
      closePopupExterior();
      closePopupInterior();
    });
  });

  popupExterior
    .querySelector(".j360-popup__overlay")
    .addEventListener("click", function () {
      closePopupExterior();
    });

  popupInterior
    .querySelector(".j360-popup__overlay")
    .addEventListener("click", function () {
      closePopupInterior();
    });

  //  exterior swiper
  swiperExterior = new Swiper("#j360_swiper_exterior", {
    loop: true,
    autoHeight: true,
  });

  //  interior swiper
  swiperInterior = new Swiper("#j360_swiper_interior", {
    loop: true,
    autoHeight: true,
  });
}

export function getSwiperExteriorElement() {
  return document.getElementById("j360_swiper_exterior");
}

export function getSwiperInteriorElement() {
  return document.getElementById("j360_swiper_interior");
}

export function getSwiperExterior() {
  return swiperExterior;
}

export function getSwiperInterior() {
  return swiperInterior;
}

export default initPopup;
